import { List } from "antd"
import { Tag } from "../../../common"

const InfoCard = ({ list, tag }) => {
  return (
    <List
      size="small"
      dataSource={list}
      renderItem={(e, index) => {
        return (
          <List.Item key={index}>
            <div className="gray-700">{`${e?.label}:`}</div>
            {e.tag && <Tag color={e?.tag?.color}>{e?.tag?.value}</Tag>}
          </List.Item>
        )
      }}
    />
  )
}

export default InfoCard
